import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import React from "react";
import { Images } from "../../../global/GloblImages.tsx";
import Domains from "../../../global/constants/domain.ts";
import clientlogin from '../../../assets/images/client-login.svg'
import shopperlogin from '../../../assets/images/shopper-login.svg'
import { Box, Button, Grid, Typography } from '@mui/material'
import { toast } from "react-toastify";
import { roleRedirects } from "../../../global/constants/roleRedirects.tsx";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../global/config/store.ts";
import { fetchClientList } from "../../../global/config/Reducer/clientSlice.ts";

const Home: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [images, setImages] = useState<string[]>([]);
  const icons: any = Images();
  const domain = window.location.hostname;
  // const [callApi, setCallApi] = useState<boolean>(false)
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>();

  
    useEffect(() => {
        if (localStorage.getItem('token')) {
            dispatch(fetchClientList());
        }
    }, [dispatch]);

  useEffect(() => {
    console.log(domain);
    const loadedImages = [icons.AldiBanner1, icons.AldiBanner2, icons.AldiBanner3];
    setImages(loadedImages);
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 7000);

      return () => clearInterval(interval);
    }
  }, [images]);


    const autologin = () => {
    try {
      const userToken = localStorage.getItem('token')
      const userRole = localStorage.getItem('userRole')

      const currentPath = window.location.pathname

      // No token → login
      if (!userToken || !userRole) {
        if (currentPath !== '/login') {
          navigate('/login', { replace: true })
        }
        return
      }

      // Validate role
      if (!["1", "2", "3"].includes(userRole)) {
        toast.error("Invalid Access")
        navigate('/login', { replace: true })
        return
      }

      // Only redirect to dashboard when visiting login
      if (currentPath === '/') {
        const redirectUrl = roleRedirects[userRole] || '/'
        navigate(redirectUrl, { replace: true })
      }

      // Otherwise stay on the current route
    } catch (error) {
      console.log("Error during autologin", error)
    }
  }

  return (
    <div  style={{height:'fit-content'}}>
      <header className="header-area header-white" style={{ marginTop: "2em" }}>
        <div className="container">
          <div className="row m-0 p-0">
            <div className="col-12 p-0" style={{ height: "80px" }}>
              <nav className="main-nav d-flex justify-content-center">
                <a
                  href="/"
                  className="logo"
                  style={{
                    background: "white",
                    padding: "1em",
                    boxShadow: "0 2px 28px 0 rgba(117, 114, 76, .6)",
                    marginTop: "-1.5em",
                    borderRadius: "10px",
                  }}
                >
                  <img
                    className="lazy"
                    alt="mystery shopping services in Australia"
                    title="secret shopper in Australia"
                    src={icons.mmLogo}
                  />
                </a>
                {/* <ul className="nav">
                  <li style={{ display: "none" }} className="active">
                    <a href="/">Home</a>
                  </li>
                  <li style={{ display: "none" }}>
                    <a href="/register-as-secret-shopper">Become A Shopper</a>
                  </li>
                  <li style={{ paddingRight: "0", display: "none" }}>
                    <a href="/contact-us">Contact</a>
                  </li>
                </ul> */}
                {/* <a className="menu-trigger">
                  <span>Menu</span>
                </a> */}
              </nav>
            </div>
          </div>
        </div>
      </header>

      <div className="welcome-area pt-0 pt-md-5" id="welcome">
        <div className="header-text bg-white" style={{ alignItems:'start', backgroundColor: 'transparent !important', width: '100%', height:'fit-content !important'}}>
          <Box className='mx-0 mt-2 mx-md-3'>
            <Grid container spacing={4} className='mx-0 px-0 mx-md-5 mt-md-5 px-md-5'>
              <Grid size={{xs:12,md:6}}>
                <h2 className="text-center mb-3">Client Login</h2>
                <hr className="m-0 p-0" />
                <Box bgcolor={'white'} className='px-4 my-3 d-flex flex-column justify-content-center align-items-center' borderRadius={'20px'}>
                  <Box component={'img'} src={clientlogin} height={'280px'}>
                  </Box>
                  <hr className="w-100 m-0 p-0 mx-2 " />
                  <Button className=" px-4 py-2 my-3" onClick={() => { window.open(process.env.REACT_APP_MM_CLIENT_SITE) }} sx={{ background: 'linear-gradient(175deg, #ccd3b4 4.38%, #607438 111.49%) !important', color: 'white', border: 'none', width: 'fit-content', fontWeight: 'bold' }}>Client Login</Button>
                </Box>
              </Grid>
              <Grid size={{xs:12,md:6}}>
                <h2 className="text-center mb-3">Shopper Login</h2>
                <hr className="m-0 p-0" />
                <Box bgcolor={'white'} className='px-4 my-3 d-flex flex-column justify-content-center align-items-center' borderRadius={'20px'}>
                  <Box component={'img'} src={shopperlogin} height={'280px'}>
                  </Box>
                  <hr className="w-100 m-0 p-0 mx-2 " />
                  <Button className=" px-4 py-2 my-3" onClick={() => { window.open(process.env.REACT_APP_SHOPPER_SITE) }} sx={{ background: 'linear-gradient(175deg, #ccd3b4 4.38%, #607438 111.49%) !important', color: 'white', border: 'none', width: 'fit-content', fontWeight: 'bold' }}>Shopper Login</Button>
                </Box>
              </Grid>
            </Grid>
            <hr />
            <Box className='d-flex justify-content-center'>
              {/* <Link
                style={{ color: 'white', border: 'none', }}

                to="/login"
              > */}
                <Button onClick={()=>{autologin()}} className=" px-4 py-2 my-0" sx={{ background: 'linear-gradient(175deg, #ccd3b4 4.38%, #607438 111.49%) !important', color: 'white', border: 'none', width: 'fit-content', fontWeight: 'bold' }}>Office Use</Button>
              {/* </Link> */}
            </Box>
            <hr />
          </Box>

          {/* </div> */}

        </div>
      </div>
    </div>
  );
};

export default Home;
